import { render, staticRenderFns } from "./CardRoomPlayerName.vue?vue&type=template&id=197711e8&scoped=true&"
import script from "./CardRoomPlayerName.vue?vue&type=script&lang=ts&"
export * from "./CardRoomPlayerName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197711e8",
  null
  
)

export default component.exports